import Event from '../../core/Event';

export default class RemoveCustomerRequested extends Event {
    public static type = 'RemoveCustomerRequested';

    constructor(public readonly customerId: string) {
        super(RemoveCustomerRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/RemoveCustomerRequested.ts